import {
  MailSignupFailModal,
  MailSignupSuccessModal,
  handleEmailSubmit,
  validateMailAddress,
} from "./utils"
import React, { useEffect, useState } from "react"
import {
  getInterestData,
  interestAbbreviation,
} from "data/newsletter-interest-abbreviations"

import { ExpandableCard } from "components/page-components/Info-Modules"
import { EnvelopeClosedIcon } from "components/page-components/Icons/small"

export const NewsletterSignup = ({
  ressort = "ausschreibungsdienste",
  choices_open,
}) => {
  const assumedInterest = getInterestData({ ressort })

  const [mailAddress, setMailAddress] = useState("")
  const updateMailaddress = (e) => setMailAddress(e.target.value)
  const [interestsArray, setInterestsArray] = useState([
    assumedInterest.abbreviation,
  ]) //needs to be an array!
  const [validEmail, setValidEmail] = useState(false)
  const [successModalClass, setSuccessModalClass] = useState("")
  const [failModalClass, setFailModalClass] = useState("")
  const [checkboxDatenschutz, setCheckboxDatenschutz] = useState(false)
  const toggleDatenschutzCheckbox = (e) => {
    e.target.tagName !== "A" && e.preventDefault()
    setCheckboxDatenschutz(!checkboxDatenschutz)
  }
  const [buttonLoading, setButtonLoading] = useState(false)

  const handleSubmit = async () => {
    setButtonLoading(true)
    handleEmailSubmit({
      list: "newsletter",
      email: mailAddress,
      interests: interestsArray,
      launchModal,
    })
  }

  const handleEnter = (e) => {
    if (e.keyCode === 13 && validEmail) {
      return handleSubmit
    }
  }

  const launchModal = (success) => {
    success ? setSuccessModalClass("is-active") : setFailModalClass("is-active")
  }

  const handleInterestChoice = (e, ressAbbr) => {
    e.persist()
    e.preventDefault()
    const newInterests = interestsArray.includes(ressAbbr)
      ? interestsArray.filter((ab) => ab !== ressAbbr)
      : [...interestsArray, ressAbbr]

    setInterestsArray(newInterests)
  }

  const Checkbox = ({ choice }) => {
    const handleCheck = (e) =>
      handleInterestChoice(e, interestAbbreviation[choice].abbreviation)
    const selected = interestsArray.some(
      (interest) => interest === interestAbbreviation[choice].abbreviation
    )
    return (
      <div
        data-nosnippet
        className="column is-full pb-2"
        onClick={handleCheck}
        onKeyPress={() => {}}
        role="button"
        tabIndex="-1"
        aria-label="Select B_I baumagazin"
      >
        <input
          type="checkbox"
          id="bmCheckbox"
          name="bmCheckbox"
          onChange={() => {}}
          checked={selected}
        />
        <label htmlFor="bmCheckbox" aria-label="baumagazin">
          <span className="pl-3">
            <b>{interestAbbreviation[choice].short_description}</b>
          </span>
        </label>
      </div>
    )
  }

  useEffect(() => {
    setValidEmail(validateMailAddress(mailAddress))
  }, [mailAddress])

  return (
    <div data-nosnippet className={`section has-background-${ressort} `}>
      <div className="container">
        <div className="columns is-centered">
          <div className="column is-8-fullhd is-10-widescreen is-12-desktop">
            <div className="columns is-centered is-gapless">
              <div className="column is-8">
                <p className="title is-3 is-size-4-mobile is-spaced has-text-centered pt-5 has-text-white">
                  Jetzt zum Newsletter anmelden:
                </p>

                <p className="subtitle is-6 has-text-centered mx-5 has-text-white">
                  {assumedInterest.long_description}
                </p>
              </div>
            </div>

            <div className="columns is-centered is-vcentered is-gapless">
              <div className="column is-6">
                <div className="control has-icons-left">
                  <input
                    className="input"
                    type="text"
                    placeholder="Email"
                    onChange={updateMailaddress}
                    onKeyDown={handleEnter}
                    aria-label="email-newsletter"
                  />
                  <span className="icon is-medium is-left">
                    <EnvelopeClosedIcon {...{ color: "#b3cbd4" }} />
                  </span>
                </div>
              </div>
              <div className="column is-2 has-text-centered">
                <button
                  className={`button is-sonnengelb is-fullwidth ${
                    buttonLoading ? "is-loading" : ""
                  }`}
                  disabled={
                    !validEmail ||
                    !checkboxDatenschutz ||
                    interestsArray.length < 1
                  }
                  onClick={handleSubmit}
                >
                  <b>Anmelden</b>
                </button>
              </div>
            </div>

            <div
              className="columns is-centered is-multiline is-gapless signup-checkboxes "
              style={{
                transition: `.2s ease`,
                maxHeight: validEmail ? "200px" : "0px",
                opacity: validEmail ? "1" : "0",
                visibility: validEmail ? "visible" : "hidden",
              }}
            >
              <div
                onClick={toggleDatenschutzCheckbox}
                onKeyPress={() => {}}
                role="button"
                tabIndex="-5"
                aria-label="Select Datenschutzbestimmungen"
                className="column is-8"
              >
                <input
                  type="checkbox"
                  id="datenschutzCheckboxNewsletter"
                  name="datenschutzCheckboxNewsletter"
                  onChange={() => {}}
                  checked={checkboxDatenschutz}
                />
                <label htmlFor="datenschutzCheckboxNewsletter">
                  <span className="pl-3 has-text-white">
                    Ich akzeptiere die Bestimmungen zum{" "}
                    <a
                      href="/datenschutzerklaerung"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "white" }}
                      className="link"
                    >
                      Datenschutz
                    </a>
                    .
                  </span>
                </label>
              </div>
            </div>

            <div className="columns is-centered is-gapless">
              <div className="column is-8">
                <ExpandableCard
                  {...{
                    open_by_default: choices_open,
                    title: "Weitere Newsletter und Informationen",
                  }}
                >
                  <div className="columns is-centered is-marginless is-paddingless is-gapless is-multiline signup-checkboxes">
                    <Checkbox choice="baumagazin" />
                    <Checkbox choice="galabau" />
                    <Checkbox choice="umweltbau" />
                    <Checkbox choice="ausschreibungsdienste" />
                  </div>
                </ExpandableCard>
              </div>
            </div>

            <MailSignupSuccessModal
              {...{
                ressort,
                successModalClass,
                setButtonLoading,
                setSuccessModalClass,
              }}
            />

            <MailSignupFailModal
              {...{
                ressort,
                failModalClass,
                setButtonLoading,
                setFailModalClass,
              }}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
